import { Theme } from "@mui/material";

// Use these mappings to convert API keys to Infegy color keys (infegyColor.ts)
export function getFullFieldToColor(theme:Theme, field: string, key: string): string | undefined {
  const infegyColorKey = getFieldToColor(field, key);
  if (infegyColorKey && Object.prototype.hasOwnProperty.call(theme.colors.namedColors, infegyColorKey)) {
    return theme.colors.namedColors[infegyColorKey];
  }
  return undefined;
}

export function getFieldToColor(field: string, key: string): string | undefined {
  return fieldToColor[field]?.[key] ?? undefined;
}

export const fieldToColor: Record<string, Record<string, string>> = {
  sentiment: {
    "p": "positive",
    "n": "negative",
    "0": "neutral"
  },
  gender: {
    "m": "male",
    "f": "female",
    "n": "nonbinary",
    null: "uncategorized" // "null" being the key for "[missing]" values
  }
};